import { ReactComponent as ARROW_DONW } from "@/assets/icons/arrow-down.svg";
import { formatPrice } from "@/utils/number";
import { FC } from "react";

interface HighLightCardProptypes {
  title: string;
  value: string;
  percentage: string;
  status: "up" | "down";
}

const HighLightCard: FC<HighLightCardProptypes> = ({
  title,
  value,
  percentage,
  status = "up",
}) => {
  return (
    <div className="highlight-card-component">
      <span className="card-title">{title}</span>
      <div className="content-wraper">
        <span className="value">{formatPrice(value, ",")}</span>
        {/* <div className={"percentage-info" + ` ${status}`}>
          <ARROW_DONW />
          <span className="percentage">{percentage}</span>
        </div> */}
      </div>
    </div>
  );
};

export default HighLightCard;
